var _path, _path2, _line, _path3, _path4, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultsOverProcess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5468 16.2546C38.2126 22.1342 37.0867 29.3497 32.1948 34.2416C25.912 40.5244 15.7963 40.5951 9.60077 34.3996C3.40523 28.2041 3.47597 18.0885 9.75877 11.8057C14.6709 6.89354 21.9261 5.77869 27.8188 8.48702",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7745 18.2263C28.3725 20.8244 28.3569 25.0858 25.698 27.7447C23.0391 30.4036 18.7776 30.4191 16.1796 27.8211C13.5816 25.2231 13.5972 20.9617 16.2561 18.3028C18.915 15.6439 23.1764 15.6283 25.7745 18.2263Z",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 22.9611,
    y2: -1,
    transform: "matrix(0.707109 -0.707105 0.707109 0.707105 21.5986 23.6821)",
    stroke: "#C63031",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2507 10.5879L31.6778 4.95604L26.4011 10.2327L27.9739 15.8646",
    stroke: "#C63031",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2508 10.5877L39.1919 12.4699L33.9152 17.7465L27.9741 15.8644",
    stroke: "#C63031",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.83294,
    cy: 1.80748,
    rx: 1.83294,
    ry: 1.80748,
    transform: "matrix(0.707109 -0.707105 0.707109 0.707105 18.4023 23.0403)",
    fill: "#C63031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsOverProcess);
export default __webpack_public_path__ + "static/media/Results Over Process.f603c62f5b5cdfab079597ec482149b2.svg";
export { ForwardRef as ReactComponent };